'use strict';
require('../../modules/es.array.to-spliced');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'toSpliced');
